import React from 'react';

import '../CSS/Heading.css';

function Heading() {
    return (<div className="Title">
        <header>
            StockDash
        </header>
    </div>)
}
export default Heading;
